import { render, staticRenderFns } from "./BesoinsParent.vue?vue&type=template&id=df1a0910&"
import script from "./BesoinsParent.vue?vue&type=script&lang=js&"
export * from "./BesoinsParent.vue?vue&type=script&lang=js&"
import style0 from "./BesoinsParent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports